import React from 'react'
import PropTypes from 'prop-types'

import { ReactComponent as PlayIcon } from '../../../../../../../assets/icons/play-icon3.svg'
import { ReactComponent as PauseIcon } from '../../../../../../../assets/icons/pause-icon.svg'
import Icon from '../../../../../../../components/Icon'
import Loader from '../../../../../../../components/Loaders/Loader'

import useStyles from './styles'

const VideoOverlay = ({
  showVideoElement,
  isVideoLoaded,
  isPaused,
  togglePlay,
  requestedVideoUrlData,
  onInitialPlayPress,
  hideLoader
}) => {
  const classes = useStyles()

  // this icon is shown when the video is not loaded yet, and we actually show the video picture
  if (!showVideoElement) {
    return (
      <div className={classes.overlay} onClick={onInitialPlayPress}>
        <Icon className={classes.icon}>
          <PlayIcon />
        </Icon>
      </div>
    )
  }

  // this icon is custom play/pause button which is shown on hover
  if (showVideoElement && !isVideoLoaded && !hideLoader) {
    return (
      <div className={classes.overlay}>
        <Icon className={classes.loader}>
          <Loader />
        </Icon>
      </div>
    )
  }

  // Overlay for play/pause controls (only show if no iframe_src is needed)
  if (showVideoElement && isVideoLoaded && !requestedVideoUrlData?.iframe_src) {
    return (
      <div className={classes.overlay} onClick={togglePlay}>
        <div className={classes.playPauseButtons}>
          {isPaused ? (
            <Icon className={classes.icon}>
              <PlayIcon />
            </Icon>
          ) : (
            <Icon className={classes.icon}>
              <PauseIcon />
            </Icon>
          )}
        </div>
      </div>
    )
  }

  return null
}

VideoOverlay.propTypes = {
  showVideoElement: PropTypes.bool.isRequired,
  isVideoLoaded: PropTypes.bool.isRequired,
  videoError: PropTypes.bool.isRequired,
  isPaused: PropTypes.bool.isRequired,
  togglePlay: PropTypes.func.isRequired,
  requestedVideoUrlData: PropTypes.object,
  onInitialPlayPress: PropTypes.func.isRequired,
  hideLoader: PropTypes.bool
}

export default VideoOverlay
